/**
 * Kayıt (legacy HTML) formlarındaki şifre alanlarına göster/gizle düğmesi ekler.
 */
export function initAuthPasswordToggles(root = document) {
  const scope = root.querySelector('.pp-auth-legacy-register') || root;

  scope.querySelectorAll('input[type="password"]').forEach((input) => {
    if (!input.id || input.closest('.password-input-wrap')) return;

    const wrap = document.createElement('div');
    wrap.className = 'password-input-wrap';
    input.parentNode.insertBefore(wrap, input);
    wrap.appendChild(input);

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'password-toggle';
    btn.dataset.target = input.id;
    btn.setAttribute('aria-label', 'Şifreyi göster');
    btn.setAttribute('title', 'Şifreyi göster');
    btn.innerHTML = '<i class="fas fa-eye" aria-hidden="true"></i>';
    wrap.appendChild(btn);
  });

  scope.querySelectorAll('.password-toggle').forEach((btn) => {
    if (btn.dataset.ppPwdToggleBound) return;
    btn.dataset.ppPwdToggleBound = '1';

    btn.addEventListener('click', () => {
      const input = document.getElementById(btn.dataset.target);
      const icon = btn.querySelector('i');
      if (!input || !icon) return;

      if (input.type === 'password') {
        input.type = 'text';
        icon.classList.remove('fa-eye');
        icon.classList.add('fa-eye-slash');
        btn.setAttribute('aria-label', 'Şifreyi gizle');
        btn.setAttribute('title', 'Şifreyi gizle');
      } else {
        input.type = 'password';
        icon.classList.remove('fa-eye-slash');
        icon.classList.add('fa-eye');
        btn.setAttribute('aria-label', 'Şifreyi göster');
        btn.setAttribute('title', 'Şifreyi göster');
      }
    });
  });
}
